import React, {FC} from 'react';
import InputLabel from '@material-ui/core/InputLabel';
import {Box} from '@material-ui/core';
import 'react-color-gradient-picker/dist/index.css';
import ColorPicker from "@common/color-picker";
import Launchpad from '@common/launchpad';
import {Track, MusicPaperShape, Color} from "@consts/types";
import {SidebarContainer} from '../../styleds/sidebar';

type SidebarProps = {
  selectShape: MusicPaperShape | null;
  background: Color;
  onColorChange: (color: Color) => void;
  onTrackChange: (track: Track) => void;
}
 
const Sidebar:FC<SidebarProps> = ({
  selectShape,
  background,
  onColorChange,
  onTrackChange
}) => {
  const { color, track } = selectShape || {};
  return (
    <SidebarContainer>
      <Box sx={{ mb: 5 }}>
        <Box sx={{ mb: 1 }} >
          <InputLabel>Color</InputLabel>
        </Box>
        <ColorPicker
          id={selectShape?.id}
          color={color || background}
          onChange={(color) => onColorChange(color)}
        />
      </Box>
      {!!selectShape && (
        <Box>
          <Box sx={{ mb: 1 }}>
            <Box sx={{ mb: 1 }}>
              <InputLabel>Sound</InputLabel>
            </Box>
          </Box>
          <Launchpad
            track={track || null}
            onTrackChange={(track) => onTrackChange(track)}
          />
        </Box>
      )}
    </SidebarContainer>
  )
}


export default Sidebar